import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { he, en } from "vuetify/locale";

export default createVuetify({
  components,
  directives,
  locale: {
    locale: "he",
    fallback: "en",
    messages: { he, en },
    rtl: true,
  },
  defaults: {
    VApp: {
      style: {
        fontFamily:
          "'Poppins', 'Inter', 'Noto Sans Hebrew', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      },
    },
    VBtn: {
      style: {
        fontFamily:
          "'Poppins', 'Inter', 'Noto Sans Hebrew', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontWeight: 500,
      },
    },
    VCard: {
      style: {
        fontFamily:
          "'Poppins', 'Inter', 'Noto Sans Hebrew', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      },
    },
    VTextField: {
      style: {
        fontFamily:
          "'Poppins', 'Inter', 'Noto Sans Hebrew', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      },
    },
    VDataTable: {
      style: {
        fontFamily:
          "'Poppins', 'Inter', 'Noto Sans Hebrew', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      },
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#f7f8fa",
          surface: "#ffffff",
          primary: "#23272f", // כחול-אפור כהה
          secondary: "#6c757d", // אפור-כחול רגוע
          accent: "#495057",
          info: "#3a3d42",
          success: "#4caf50",
          warning: "#ffb300",
          error: "#e53935",
          text: "#23272f",
          card: "#f7f8fa",
        },
      },
      dark: {
        dark: true,
        colors: {
          background: "#181a1b",
          surface: "#23272f",
          primary: "#e0e0e0", // לבן-אפור בהיר
          secondary: "#b0b8c1", // אפור-כחול בהיר
          accent: "#adb5bd",
          info: "#b0b8c1",
          success: "#81c784",
          warning: "#ffd54f",
          error: "#ef5350",
          text: "#e0e0e0",
          card: "#23272f",
        },
      },
    },
  },
});
